// src/pages/HomePage.tsx
import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Paper, Grid, Divider, useTheme, useMediaQuery, Fade } from '@mui/material';
import './HomePage.css';

const HomePage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <Box className="home-page-background">
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Fade in={loaded} timeout={1000}>
          <Paper 
            elevation={3} 
            sx={{ 
              p: { xs: 3, md: 5 }, 
              borderRadius: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
            }}
          >
            <Grid container spacing={4}>
              {/* Profile Picture Area - WITH WORKAROUND */}
              <Grid {...{ item: true, xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box className="profile-picture-container">
                  {/* Placeholder for profile picture */}
				   <Box component="img" src="/path/to/your/profile-picture.jpg" className="profile-picture" />
                  
                  <Typography variant="h5" align={isMobile ? 'center' : 'left'} sx={{ mt: 2, fontWeight: 'bold' }}>
                    Ilisio Viana
                  </Typography>
                  <Typography variant="subtitle1" align={isMobile ? 'center' : 'left'} color="primary" sx={{ mb: 2 }}>
                    AI & Software Engineering Leader
                  </Typography>
                  
                  {/* Social links - optional */}
                  <Box className="social-links">
                    {/* Add your social media or contact icons here */}
                  </Box>
                </Box>
              </Grid>

              {/* Bio Content - WITH WORKAROUND */}
              <Grid {...{ item: true, xs: 12, md: 8 }}>
                <Typography variant="h4" component="h1" gutterBottom color="primary">
                  About Me
                </Typography>
                <Divider sx={{ mb: 3 }} />
                
                <Typography variant="body1" paragraph>
                  Senior AI and Software Engineering Leader bridging cutting-edge technical innovation with strategic organizational change. I leverage a unique interdisciplinary background—a Ph.D. in Computer Vision and a Master's in Signal, Image Processing, and Artificial Intelligence—built on extensive experience in both academia and industry. I have a proven track record of solving real-world challenges across sectors including energy, aeronautics, biomedical (dental), space, and automotive.
                </Typography>
                
                <Typography variant="body1" paragraph>
                  To further strengthen this foundation, I earned a Master's in Human Resources and Change Management to bridge the gap between technology and organizational strategy. This unique blend enables me to align innovation with leadership and drive impactful transformation initiatives.
                </Typography>
                
                <Typography variant="body1" paragraph>
                  Currently, I lead a Software Engineering, AI, and Machine Learning team focused on developing in-house applications for the EMEA automotive sector. Our mission is to enhance operational efficiency through digitalization and deliver AI and ML solutions that optimize machine and process performance.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default HomePage;
